(function () {
  "use strict";

  function normalizeReviewNaming(section) {
    var canonicalTitles = {
      "Clearvell™ Copper Foot Sleeve": "Clearvell™ Copper OrthoPro Foot Sleeve",
      "Clearvell™ Foot Support Sleeve": "Clearvell™ OrthoPro Foot Sleeve"
    };

    section.querySelectorAll(".review-product-title").forEach(function (title) {
      var current = title.textContent.trim();
      if (canonicalTitles[current]) {
        title.textContent = canonicalTitles[current];
      }
    });

    section.querySelectorAll(".review-product-image img").forEach(function (image) {
      var alt = (image.getAttribute("alt") || "").trim();
      if (canonicalTitles[alt]) {
        image.setAttribute("alt", canonicalTitles[alt]);
      }
    });

    section.querySelectorAll(".review-text").forEach(function (review) {
      review.textContent = review.textContent
        .replace(/Copper Foot Sleeve/g, "Copper OrthoPro Foot Sleeve")
        .replace(/Foot Support Sleeve/g, "OrthoPro Foot Sleeve");
    });
  }

  function initCarousel(section) {
    normalizeReviewNaming(section);

    var container = section.querySelector(".reviews-carousel-swiper");
    if (!container || container.swiper) return;

    var prevButton = section.querySelector(".global-nav-button.prev, .nav-button.prev");
    var nextButton = section.querySelector(".global-nav-button.next, .nav-button.next");

    var swiperLoad =
      typeof window.swiperCheckAndLoad === "function"
        ? window.swiperCheckAndLoad()
        : Promise.resolve();

    swiperLoad.then(function () {
      if (!container || container.swiper) return;
      if (typeof window.Swiper === "undefined") return;

      container.classList.remove("reviews-carousel-swiper--pending");

      var spaceBetween = 20;
      var slidesPerViewMobile = "auto";
      var centerDesktop = section.dataset.centerCardsDesktop === 'true';
      var centerMobile = section.dataset.centerCardsMobile === 'true';
      var slideCount = container.querySelectorAll('.swiper-slide').length;
      var isMobile = window.innerWidth < 768;
      var shouldCenter = isMobile ? centerMobile : centerDesktop;
      var initialSlide = shouldCenter ? Math.floor(slideCount / 2) : 0;

      var breakpoints = {};
      breakpoints[768] = {
        spaceBetween: spaceBetween,
        slidesPerView: "auto",
        centeredSlides: centerDesktop,
        centeredSlidesBounds: centerDesktop,
        centerInsufficientSlides: centerDesktop
      };

      var swiperConfig = {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: spaceBetween,
        loop: false,
        speed: 400,
        centeredSlides: centerMobile,
        centeredSlidesBounds: centerMobile,
        centerInsufficientSlides: centerMobile,
        initialSlide: initialSlide,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          hideOnClick: false,
          disabledClass: "nav-button-disabled"
        },
        breakpoints: breakpoints,
        observer: true,
        observeParents: true
      };

      var swiper = new window.Swiper(container, swiperConfig);

      swiper.on('breakpoint', function() {
        setTimeout(function() {
          var isDesktop = window.innerWidth >= 768;
          var shouldCenter = isDesktop ? centerDesktop : centerMobile;
          var targetSlide = shouldCenter ? Math.floor(slideCount / 2) : 0;
          swiper.slideTo(targetSlide, 0, false);
        }, 50);
      });
    });
  }

  function runInit() {
    var sections = document.querySelectorAll(".reviews-transformation-section");
    sections.forEach(function (section) {
      normalizeReviewNaming(section);
      if (section.querySelector(".reviews-carousel-swiper")) {
        initCarousel(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector && e.target.querySelector(".reviews-transformation-section");
    if (section) {
      normalizeReviewNaming(section);
      initCarousel(section);
    } else if (e.target.classList && e.target.classList.contains("reviews-transformation-section")) {
      normalizeReviewNaming(e.target);
      initCarousel(e.target);
    }
  });
})();